export let User;
(function (_User) {
  let SignInFlow = /*#__PURE__*/function (SignInFlow) {
    SignInFlow["GOOGLE"] = "google";
    SignInFlow["PASSWORD"] = "password";
    SignInFlow["SSO"] = "sso";
    return SignInFlow;
  }({});
  _User.SignInFlow = SignInFlow;
  let UseCaseAnswer = /*#__PURE__*/function (UseCaseAnswer) {
    UseCaseAnswer["UNKNOWN"] = "unknown";
    UseCaseAnswer["CAMPAIGNS"] = "campaigns";
    UseCaseAnswer["CONTACTS"] = "contacts";
    UseCaseAnswer["STORIES"] = "stories";
    UseCaseAnswer["NEWSROOM"] = "newsroom";
    UseCaseAnswer["COVERAGE"] = "coverage";
    UseCaseAnswer["SKIP"] = "skip";
    return UseCaseAnswer;
  }({});
  _User.UseCaseAnswer = UseCaseAnswer;
})(User || (User = {}));